/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForKubernetesClusterPlatformManaged extends models.ServiceAccountCredentialsBaseForKubernetesCluster {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForKubernetesClusterPlatformManaged");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForKubernetesClusterPlatformManaged.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForKubernetesClusterPlatformManaged>): ServiceAccountCredentialsForKubernetesClusterPlatformManaged {
        let obj = Object.assign(new ServiceAccountCredentialsForKubernetesClusterPlatformManaged(), model);
        ServiceAccountCredentialsForKubernetesClusterPlatformManaged.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForKubernetesClusterPlatformManaged>): ServiceAccountCredentialsForKubernetesClusterPlatformManaged {
        if (!model) return null;
        return ServiceAccountCredentialsForKubernetesClusterPlatformManaged.newInstance(<ServiceAccountCredentialsForKubernetesClusterPlatformManaged> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForKubernetesClusterPlatformManaged) {
        if (!obj) return;

        models.ServiceAccountCredentialsForKubernetesClusterPlatformManaged.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForKubernetesClusterPlatformManaged): boolean {
        if (models.ServiceAccountCredentialsBaseForKubernetesCluster.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForKubernetesClusterPlatformManaged.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
